export default __webpack_public_path__ + "static/media/PamBeesly.df5fe60d.jpg";